/* ---- Custom UGC Slider ---- */
$(function() {
  const $track = $('#hethUgcSliderTrack');
  if (!$track.length) return;

  const $slides = $('.heth-ugc-slide');
  const $prevBtn = $('#hethUgcPrev');
  const $nextBtn = $('#hethUgcNext');
  let currentIndex = 2; // Start with the middle slide (index 2) active
  const totalSlides = $slides.length;

  function updateSlider(isDraggingMove = false) {
    const isTablet = window.innerWidth <= 1023;
    const isMobile = window.innerWidth <= 767;

    let wActive = 421, hActive = 638;
    let w1 = 342, h1 = 570;
    let w2 = 274, h2 = 489;
    let w3 = 200, h3 = 340;
    let GAP = 20;

    if (isTablet && !isMobile) {
      wActive = 340; hActive = 515;
      w1 = 280; h1 = 466;
      w2 = 220; h2 = 392;
      w3 = 160; h3 = 280;
      GAP = 16;
    }
    
    if (isMobile) {
      wActive = 289; hActive = 440;
      w1 = 235; h1 = 387;
      w2 = 180; h2 = 314;
      w3 = 120; h3 = 210;
      GAP = 12;
    }

    let sizes = [
      { w: wActive, h: hActive },
      { w: w1, h: h1 },
      { w: w2, h: h2 },
      { w: w3, h: h3 }
    ];

    let dists = [0];
    for (let i = 1; i <= 3; i++) {
      dists[i] = dists[i-1] + sizes[i-1].w / 2 + GAP + sizes[i].w / 2;
    }

  let dragOffset = 0;
    if (isDraggingMove && currentX !== 0) {
      let diffX = currentX - startX;
      let slideDist = dists[1]; // distance between center and first adjacent
      dragOffset = diffX / slideDist;
    }

    $slides.each(function(index) {
      const $slide = $(this);
      if (!isDraggingMove) {
        $slide.removeClass('active playing');
      }
      
      const vid = $slide.find('video')[0];
      if (vid && index !== currentIndex && !isDraggingMove) {
        vid.pause();
        vid.currentTime = 0;
      }

      let diff = index - currentIndex;
      let exactDiff = diff + dragOffset; // fixed from - to + to slide in the correct direction

      // Adjust exactDiff for infinite loop wrap-around
      let half = totalSlides / 2;
      while (exactDiff > half) exactDiff -= totalSlides;
      while (exactDiff < -half) exactDiff += totalSlides;

      // Calculate the integer diff for CSS class assignments when not dragging
      let intDiff = diff;
      if (intDiff > Math.floor(totalSlides / 2)) intDiff -= totalSlides;
      else if (intDiff < -Math.floor(totalSlides / 2)) intDiff += totalSlides;

      if (!isDraggingMove && intDiff === 0) {
        $slide.addClass('active');
      }

      // Prevent flying across screen on integer wrap-around when drag ends
      let prevDiff = $slide.data('prevDiff');
      let isWrapping = false;
      if (!isDraggingMove) {
        if (prevDiff !== undefined && Math.abs(intDiff - prevDiff) > totalSlides / 2) {
           isWrapping = true;
        }
        $slide.data('prevDiff', intDiff);
      }

      let absDiff = Math.abs(exactDiff);
      let currentW, currentH, translateX, zIndex, opacity;

      if (absDiff < 3) {
        let floor = Math.floor(absDiff);
        let ceil = floor + 1;
        let ratio = absDiff - floor;

        currentW = sizes[floor].w + (sizes[ceil].w - sizes[floor].w) * ratio;
        currentH = sizes[floor].h + (sizes[ceil].h - sizes[floor].h) * ratio;
        let pos = dists[floor] + (dists[ceil] - dists[floor]) * ratio;
        translateX = exactDiff >= 0 ? pos : -pos;
        zIndex = 100 - Math.round(absDiff);
        opacity = 1;
      } else {
        let extra = absDiff - 3;
        currentW = sizes[3].w;
        currentH = sizes[3].h;
        let pos = dists[3] + extra * (sizes[3].w + GAP);
        translateX = exactDiff >= 0 ? pos : -pos;
        zIndex = 100 - Math.round(absDiff);
        
        // Hide elements that move too far into the back to prevent seeing them wrap
        opacity = 1 - (absDiff - 3) * 2;
        if (opacity < 0) opacity = 0;
      }

      // If it is wrapping around precisely now, force it to be invisible
      if (isWrapping) {
        opacity = 0;
      }

      $slide.css({
        width: currentW + 'px',
        height: currentH + 'px',
        transform: `translateX(${translateX}px)`,
        zIndex: zIndex,
        opacity: opacity,
        visibility: opacity === 0 ? 'hidden' : 'visible',
        transition: (isDraggingMove || isWrapping) ? 'none' : 'all 0.5s var(--ease)'
      });
      
      if (isWrapping) {
        $slide[0].offsetHeight; // Force reflow
      }
    });
  }

  $prevBtn.on('click', function() {
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    updateSlider();
  });

  $nextBtn.on('click', function() {
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSlider();
  });

  $slides.on('click', function() {
    if (isClickPrevented) return;

    const clickedIndex = $(this).index();
    
    if (clickedIndex === currentIndex) {
      const $activeSlide = $(this);
      const vid = $activeSlide.find('video')[0];
      if (vid && vid.paused) {
        $activeSlide.addClass('playing');
        vid.muted = false;
        vid.play();
      } else if (vid && !vid.paused) {
        $activeSlide.removeClass('playing');
        vid.pause();
      }
    } else {
      currentIndex = clickedIndex;
      updateSlider();
      
      setTimeout(() => {
        const $activeSlide = $('.heth-ugc-slide.active');
        const vid = $activeSlide.find('video')[0];
        if (vid) {
          $activeSlide.addClass('playing');
          vid.muted = true;
          vid.play().catch(e => console.log('Autoplay prevented', e));
        }
      }, 500);
    }
  });

  $('.heth-ugc-play-btn').on('click', function(e) {
    e.stopPropagation();
    const $slide = $(this).closest('.heth-ugc-slide');
    if ($slide.hasClass('active')) {
      const vid = $slide.find('video')[0];
      if (vid) {
        $slide.addClass('playing');
        vid.muted = false;
        vid.play();
      }
    }
  });

  let isDragging = false;
  let isClickPrevented = false;
  let startX = 0;
  let currentX = 0;
  const swipeThreshold = 50;
  let rafId = null;

  function dragStart(e) {
    if (e.type === 'touchstart') {
      startX = e.originalEvent.touches[0].clientX;
    } else {
      startX = e.clientX;
    }
    isDragging = true;
    currentX = startX;
    $track.addClass('dragging');
  }

  function dragMove(e) {
    if (!isDragging) return;
    
    if (e.type === 'touchmove') {
      currentX = e.originalEvent.touches[0].clientX;
    } else {
      currentX = e.clientX;
    }
    
    if (Math.abs(currentX - startX) > 5) {
      if (!rafId) {
        rafId = requestAnimationFrame(() => {
          updateSlider(true);
          rafId = null;
        });
      }
    }
  }

  function dragEnd(e) {
    if (!isDragging) return;
    
    $track.removeClass('dragging');
    
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    
    if (currentX !== 0 && Math.abs(currentX - startX) > 5) {
      let diffX = currentX - startX;
      
      let isTablet = window.innerWidth <= 1023;
      let isMobile = window.innerWidth <= 767;
      let slideDist = 421 / 2 + 20 + 342 / 2;
      if (isTablet && !isMobile) slideDist = 340 / 2 + 16 + 280 / 2;
      if (isMobile) slideDist = 260 / 2 + 12 + 200 / 2;

      let dragOffset = diffX / slideDist;
      let steps = Math.round(dragOffset);
      
      if (steps === 0 && Math.abs(diffX) > swipeThreshold) {
        steps = Math.sign(diffX);
      }
      
      if (steps !== 0) {
        currentIndex = (currentIndex - steps + totalSlides * 100) % totalSlides;
      }
      
      isClickPrevented = true;
      setTimeout(() => isClickPrevented = false, 50);
    }
    
    isDragging = false;
    startX = 0;
    currentX = 0;
    
    updateSlider();
  }

  $track.on('touchstart mousedown', dragStart);
  $(window).on('touchmove mousemove', dragMove);
  $(window).on('touchend mouseup', dragEnd);

  // Prevent default image drag to not interfere with custom drag
  $track.find('img, video').on('dragstart', function(e) {
    e.preventDefault();
  });
  
  // Re-calculate on resize
  $(window).on('resize', function() {
    updateSlider();
  });

  // Initialize
  updateSlider();
});
